module.exports = __webpack_public_path__ + "img/bg_pattern.5e499313.png";